const NavbarActionTypes = {
    TOGGLE_NAVBAR: 'TOGGLE_NAVBAR'
}

export default NavbarActionTypes